import { Link } from "react-router-dom";
import Marquee from "@/components/Marquee";
import ContactRail from "@/components/ContactRail";

const STORIA_IMG =
  "https://images.unsplash.com/photo-1603901622056-0a5bee231395?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwZHJhd2luZyUyMGJsdWVwcmludHMlMjB0b29sc3xlbnwwfHx8fDE3OTI5NzczODd8MA&ixlib=rb-4.1.0&q=85";

export default function Storia() {
  return (
    <>
      <section className="bg-[var(--paper)] py-24 md:py-32 px-6 border-b border-[var(--ink)]/10" data-testid="storia-page">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6 space-y-6">
            <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-deep)] block">
              La Mia Storia
            </span>
            <h1 className="font-display text-[clamp(32px,3.8vw,52px)] font-bold leading-tight">
              <span className="asc-ln"><span>25 Anni di solida esperienza.</span></span>
            </h1>
            <div className="space-y-4 text-base text-[var(--ink)]/80 leading-relaxed">
              <p>
                Ho iniziato 25 anni fa nel settore della costruzione e ristrutturazione di immobili. Vivere il cantiere
                significa comprendere la qualità vera di muri, impianti e rifiniture.
              </p>
              <p>
                Dopo 10 anni ho aperto la mia agenzia immobiliare per offrire consulenze trasparenti e valorizzare ogni
                proprietà senza sovrastime illusorie o ribassi ingiustificati.
              </p>
              <p>
                Questo doppio sguardo — tecnico e commerciale — è quello che metto ogni giorno al servizio di chi
                vende, compra o affitta con Ascari Home Consulting.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4 pt-2 font-mono-lbl">
              <div className="bg-white p-4 border border-[var(--ink)]/10 rounded">
                <span className="text-2xl font-bold text-[var(--gold-deep)] block">10 Anni</span>
                <span className="text-xs text-[var(--ink)]/70 uppercase">Cantiere Edile</span>
              </div>
              <div className="bg-white p-4 border border-[var(--ink)]/10 rounded">
                <span className="text-2xl font-bold text-[var(--ink)] block">15 Anni</span>
                <span className="text-xs text-[var(--ink)]/70 uppercase">Agenzia Dedicata</span>
              </div>
            </div>
          </div>
          <div className="lg:col-span-6">
            <figure className="relative aspect-[4/3] bg-[#eceae4] border border-[var(--ink)]/10 rounded-lg overflow-hidden">
              <img
                src={STORIA_IMG}
                alt="Documentazione tecnica e strumenti di misura su tavolo da disegno"
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <figcaption className="absolute bottom-5 left-5 font-mono-lbl text-xs uppercase text-[var(--ink)] bg-white/90 px-3 py-1 rounded">
                Esperienza Tecnica Ascari
              </figcaption>
            </figure>
          </div>
        </div>
      </section>

      <Marquee />

      {/* PERCORSO */}
      <section className="bg-white py-24 md:py-32 px-6 border-b border-[var(--ink)]/10">
        <div className="max-w-6xl mx-auto">
          <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-deep)] block mb-2">
            Il Percorso
          </span>
          <h2 className="font-display text-[clamp(32px,3.8vw,52px)] font-bold leading-tight mb-12">
            Dal cantiere alla consulenza.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-[var(--paper)] border border-[var(--ink)]/10 rounded-lg p-6">
              <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-deep)] block mb-3">
                Fase 01
              </span>
              <h3 className="font-display font-bold text-lg mb-2">Costruzione e ristrutturazione</h3>
              <p className="text-sm text-[var(--ink)]/70 leading-relaxed">
                Dieci anni in cantiere tra nuove costruzioni e ristrutturazioni: la base tecnica per leggere un
                immobile oltre le apparenze.
              </p>
            </div>
            <div className="bg-[var(--paper)] border border-[var(--ink)]/10 rounded-lg p-6">
              <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-deep)] block mb-3">
                Fase 02
              </span>
              <h3 className="font-display font-bold text-lg mb-2">La mia agenzia immobiliare</h3>
              <p className="text-sm text-[var(--ink)]/70 leading-relaxed">
                La scelta di mettere l'esperienza edile al servizio diretto dei proprietari, con un'agenzia propria e
                un metodo trasparente.
              </p>
            </div>
            <div className="bg-[var(--paper)] border border-[var(--ink)]/10 rounded-lg p-6">
              <span className="font-mono-lbl text-xs uppercase tracking-widest text-[var(--gold-deep)] block mb-3">
                Fase 03
              </span>
              <h3 className="font-display font-bold text-lg mb-2">Ascari Home Consulting oggi</h3>
              <p className="text-sm text-[var(--ink)]/70 leading-relaxed">
                Valutazioni precise e trasparenti, vendite e affitti seguiti in prima persona, dal sopralluogo al
                rogito.
              </p>
            </div>
          </div>

          <div className="mt-12">
            <Link
              to="/calcolatore"
              data-testid="storia-cta-calcolatore"
              className="inline-block px-8 py-4 bg-[var(--ink)] text-[var(--gold-light)] font-mono-lbl text-xs uppercase tracking-widest font-bold rounded hover:bg-[var(--gold)] hover:text-[var(--ink)] transition-colors"
            >
              Prova il Calcolatore di Stima →
            </Link>
          </div>
        </div>
      </section>

      <ContactRail />
    </>
  );
}
